export function setCompleteColumns(u) {
  return [
    {
      zh: "时间",
      en: "Time",
      dataIndex: "datetime",
      key: "datetime",
      visible: true
    },
    {
      zh: "平均用气量(" + u + "/min)",
      en: "Average Gas Consumption(" + u + "/min)",
      dataIndex: "avgGasConsumption",
      key: "avgGasConsumption",
      visible: true
    },
    {
      zh: "最小流量(" + u + "/min)",
      en: "Minimum Flow(" + u + "/min)",
      dataIndex :"minFlow",
      key: "minFlow",
      visible: false
    },
    {
      zh: "最大流量(" + u + "/min)",
      en: "Maximum Flow(" + u + "/min)",
      dataIndex: "maxFlow",
      key: "maxFlow",
      visible: false
    },
    {
      zh: "流量计累积(" + u + ")",
      en: "Flow Meter Accumulation(" + u + ")",
      dataIndex: "flowMeterAccumulation",
      key: "flowMeterAccumulation",
      visible: true
    },
    {
      zh: "小时用电量(kW·h)",
      en: "Power per hour(kW·h)",
      dataIndex: "avgPower",
      key: "avgPower",
      visible: true
    },
    {
      zh: "最小功率(kW)",
      en: "Minimum Power(kW)",
      dataIndex: "minPower",
      key: "minPower",
      visible: false
    },
    {
      zh: "最大功率(kW)",
      en: "Maximum Power(kW)",
      dataIndex: "maxPower",
      key: "maxPower",
      visible: false
    },
    {
      zh: "电表累积(kW·H)",
      en: "Electricity Meter Accumulation(kW·H)",
      dataIndex: "electricityMeterAccumulation",
      key: "electricityMeterAccumulation",
      visible: true
    },
    {
      zh: "平均压力(MPa)",
      en: "Average Pressure(MPa)",
      dataIndex: "avgPressure",
      key: "avgPressure",
      visible: true
    },
    {
      zh: "平均单耗(kW·H/" + u + ")",
      en: "Average Consumption(kW·H/" + u + ")",
      dataIndex: "avgConsumption",
      key: "avgConsumption",
      visible: true
    }
  ]
}

export const onlyDBColumns = [
  {
    zh: "时间",
    en: "Time",
    dataIndex: "datetime",
    key: "datetime",
      visible: true
  },
  {
    zh: "小时用电量(kW·h)",
    en: "Power per hour(kW·h)",
    dataIndex: "avgPower",
    key: "avgPower",
      visible: true
  },
  {
    zh: "最小功率(kW)",
    en: "Minimum Power(kW)",
    dataIndex: "minPower",
    key: "minPower",
    visible: false
  },
  {
    zh: "最大功率(kW)",
    en: "Maximum Power(kW)",
    dataIndex: "maxPower",
    key: "maxPower",
    visible: false
  },
  {
    zh: "电表累积(kW·H)",
    en: "Electricity Meter Accumulation(kW·H)",
    dataIndex: "electricityMeterAccumulation",
    key: "electricityMeterAccumulation",
      visible: true
  }
]

export function setCompletePointsOfCharts(u) {
  return [
    {
      title: {
        zh: "用气量",
        en: "Gas Consumption"
      },
      description: {
        zh: "用气量(" + u + "/min)",
        en: "Gas Consumption(" + u + "/min)"
      },
      dataIndex: "avgGasConsumption",
      key: "avgGasConsumption",
      min: "0.00",
      max: "0.00"
    },
    {
      title: {
        zh: "能耗",
        en: "Power"
      },
      description: {
        zh: "能耗(kW·H)",
        en: "Power(kW·H)"
      },
      dataIndex: "avgPower",
      key: "avgPower",
      min: "0.00",
      max: "0.00"
    },
    {
      title: {
        zh: "单耗",
        en: "Consumption"
      },
      description: {
        zh: "单耗(kW·H/" + u + ")",
        en: "Consumption(kW·H/" + u + ")"
      },
      dataIndex: "avgConsumption",
      key: "avgConsumption",
      min: "0.00000",
      max: "0.00000"
    },
    {
      title: {
        zh: "压力",
        en: "Pressure"
      },
      description: {
        zh: "压力(Bar)",
        en: "Pressure(Bar)"
      },
      dataIndex: "avgPressure",
      key: "avgPressure",
      min: "0.00",
      max: "0.00"
    }
  ]
}

export const onlyDBPointsOfCharts = [
  {
    title: {
      zh: "能耗",
      en: "Power"
    },
    description: {
      zh: "能耗(kW·H)",
      en: "Power(kW·H)"
    },
    dataIndex: "avgPower",
    key: "avgPower",
    min: "0.00",
    max: "0.00"
  }
]

export const colors = ["#B36A5F", "#5FAE96", "orange", "#4F72CB"]